
"use client";

import { ColumnDef } from "./data-table";
import { Badge } from "@/components/ui/badge";

import { User } from "./user-schema";
import { DataTableRowActions } from "./data-table-row-actions";

export const getColumns = (fetchUsers: () => void): ColumnDef<User, unknown>[] => [
  {
    accessorKey: "id",
    header: "User",
    cell: ({ row }) => <div className="w-[80px]">{row.original.id}</div>,
  },
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => {
      return (
        <span className="max-w-[500px] truncate font-medium">
          {row.original.name}
        </span>
      );
    },
  },
  {
    accessorKey: "email",
    header: "Email",
    cell: ({ row }) => {
      return (
        <span className="max-w-[500px] truncate font-medium">
          {row.original.email}
        </span>
      );
    },
  },
  {
    accessorKey: "roles",
    header: "Roles",
    cell: ({ row }) => {
      const roles = row.original.roles || [];
      return (
        <div className="flex space-x-2">
          {roles.map((role) => (
            <Badge key={role} variant="outline">{role}</Badge>
          ))}
        </div>
      );
    },
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return <DataTableRowActions row={row} fetchUsers={fetchUsers} />;
    },
  },
];
